function AudioElement(id) {
	this.id = id;

}

AudioElement.prototype.load = function(url) {
	this.url = url;
//	document.getElementById(this.id).src = url;
//	document.getElementById(this.id).load();
}

AudioElement.prototype.setVolume = function(v) {
	document.getElementById(this.id).volume = v;
}

AudioElement.prototype.play = function() {
	document.getElementById(this.id).src = this.url;
	document.getElementById(this.id).load();
	document.getElementById(this.id).play();
}